import React, {Component} from "react";
import CustomScrollbars from "../../CustomScrollbars";
import OrderItem from "./OrderItem";

class OrdersList extends Component {
    constructor(props) {
        super(props);
    }

    render () {
        const {salesOrders, cancelSalesOrder} = this.props

        return (
            <CustomScrollbars autoHeight autoHeightMin={100} autoHeightMax={500}>
                <ul className="task-list">
                {salesOrders
                    ? salesOrders.map((salesOrder, key) => (
                        <OrderItem
                            key={key}
                            salesOrder={salesOrder}
                            cancelSalesOrder={cancelSalesOrder}
                        />
                    ))
                 : null}
                </ul>
            </CustomScrollbars>
        );
    }
}

export default OrdersList;


// WEBPACK FOOTER //
// ./components/SalesOrders/List/OrdersList.js